<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>

    <el-form :model="formData" ref="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="type != 'preview' ? 'name' : ''"
            :label="'供应商名称' + (type == 'preview' ? '：' : '')"
            :class="{preview:type == 'preview'}"
          >
            <el-input v-model="formData.name" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ formData.name ? formData.name : '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            :class="{preview:type == 'preview'}"
            :label="'联系人' + (type == 'preview' ? '：' : '')"
          >
            <el-input v-model="formData.contactName" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ formData.contactName ? formData.contactName : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            :class="{preview:type == 'preview'}"
            :label="'供应商地址' + (type == 'preview' ? '：' : '')"
            :prop="type != 'preview' ? 'parentFullCodeList' : ''"
          >
            <div class="flex">
              <area-select
                v-if="type != 'preview' && showarea"
                v-model="formData.parentFullCodeList"
                :data="$pcaa"
                :level="2"
              ></area-select>
              <span
                v-else
              >{{ formData.cnProvinceName === formData.cnCityName ? `${formData.cnProvinceName + formData.cnDistrictName}` : `${formData.cnProvinceName + formData.cnCityName + formData.cnDistrictName}` }}</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            :class="{preview:type == 'preview'}"
            :label="'联系方式' + (type == 'preview' ? '：' : '')"
          >
            <el-input v-model="formData.contactInfo" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ formData.contactInfo ? formData.contactInfo : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            :class="{preview:type == 'preview'}"
            :prop="type != 'preview' ? 'details' : ''"
            :label="'详细地址' + (type == 'preview' ? '：' : '')"
          >
            <el-input v-model="formData.details" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ formData.details ? formData.details : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item
            :class="{preview:type == 'preview'}"
            :label="'备注' + (type == 'preview' ? '：' : '')"
          >
            <el-input
              show-word-limit
              :maxlength="300"
              placeholder="300字以内"
              type="textarea"
              :rows="3"
              v-model="formData.remark"
              v-if="type != 'preview'"
            ></el-input>
            <span v-else>{{ formData.remark ? formData.remark : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { regionData, CodeToText } from 'element-china-area-data'
import { saveSupplier, editSupplier } from '@/api/library/logistics'
export default {
  components: {},
  data() {
    return {
      importHeaders: '',
      uploadPath: '',
      type: '',
      formData: {
        name: '',
        contactName: '',
        parentFullCodeList: [],
        contactInfo: '',
        details: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        remark: '',
        cnProvinceName: '',
        cnCityName: '',
        cnDistrictName: '',
      },
      tableData: [],
      rules: {
        name: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        details: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        parentFullCodeList: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
      },

      clickFlag: false,
      showarea: false,
    }
  },
  created() {
    // this.reset()
    // this.formData.parentFullCodeList = ['440000', '440100', '440103']
  },
  watch: {
    'formData.parentFullCodeList': {
      handler(n) {
        console.log(n, '-------------------------')
        if (n.length == 3) {
          this.formData.cnProvinceName = this.codeToText('area', n[0], '86')
          this.formData.cnCityName = this.codeToText('area', n[1], n[0])
          this.formData.cnDistrictName = this.codeToText('area', n[2], n[1])
          this.formData.provinceCode = n[0]
          this.formData.cityCode = n[1]
          this.formData.districtCode = n[2]

          console.log(this.formData, ' this.formData')
        }
      },
    },
  },

  methods: {
    add(type) {
      console.log(type, '-------------type')
      this.showarea = true
      this.type = type
    },
    reset() {
      this.formData = {
        name: '',
        contactName: '',
        parentFullCodeList: [],
        contactInfo: '',
        details: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        remark: '',
        cnProvinceName: '',
        cnCityName: '',
        cnDistrictName: '',
      }
      this.resetForm('form')
      this.showarea = false
    },
    codeToText(fieldName, code, parentCode) {
      let name = ''
      switch (fieldName) {
        case 'area':
          for (let keyCode in this.$pcaa[parentCode]) {
            if (code == keyCode) {
              name = this.$pcaa[parentCode][keyCode]
              break
            }
          }
          return name
      }
    },
    getDetail(row, type) {
      console.log(row, 'row00000000000000000000000000000')
      this.showarea = false
      this.formData = row
      this.showarea = true
      this.type = type
    },
    submit(type, callback) {
      if (this.clickFlag) {
        return
      }
      console.log(type, 'addddd')
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.clickFlag = true
          if (type == 'add') {
            saveSupplier(this.formData)
              .then((res) => {
                this.clickFlag = false
                if (res.flag) {
                  this.reset()
                  callback(true)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                this.clickFlag = false
                console.log(error)
              })
          } else if (type == 'edit') {
            editSupplier(this.formData)
              .then((res) => {
                this.clickFlag = false
                if (res.flag) {
                  this.reset()
                  callback(true)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                this.clickFlag = false
                console.log(error)
              })
          }
        }
      })
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';

::v-deep {
  .el-form-item.preview {
    margin-bottom: 0;
  }
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
/deep/ .flex {
  .el-input--suffix .el-input__inner {
    width: 145px;
  }
}
/deep/.area-select-wrap .area-select {
  margin-left: 0px;
  // margin-right: 10px;
}
// .area-select.medium

/deep/ .area-select.medium {
  width: 146px;
  height: 39px;
}
/deep/ .area-select-wrap {
  display: flex;
}
/deep/ .area-select .area-selected-trigger {
  padding: 0 0 0 10px;
}
.flex {
  display: flex;
}
.area-select {
  height: 38px;
}
</style>